<template>
    <router-link :to="{
        name: 'CAR_TRAIN',
        query: {
            seriesName: carInfo.series_name
        },
        params: {
            serid: carInfo.series_id
        }}"
    >
        <img v-if="type === 'img'" class="car-img" src="@/assets/images/bitmap-small.png" v-real-src="carInfo.img" />
        <p v-else class="car-name-in">{{carInfo.series_name}}</p>
    </router-link>
</template>
<script>
/**
 * @file
 * @author
 */
export default {
    props: {
        carInfo: {
            type: Object,
            default: {}
        },
        type: {
            type: String,
            default: 'img'
        }
    }
};
</script>

<style lang="less" scoped>
.car-name-in {
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 16px;
    color: #333333;
}
.car-img {
    width: 120px;
    height: 80px;
}
</style>
